import { Fragment } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import { TableCell } from "@volca/ui/components/ui/table";
import { DROPPED, WORD } from "@/payroll/editor/diff-marks";
import type { EnrichedRosterMember } from "@/payroll/editor/types";

const SIDES = [
  { key: "before", label: "Before: ", mark: DROPPED },
  { key: "after", label: "After: ", mark: WORD.added },
] as const;

export const TeamsCol = ({ member }: { member: EnrichedRosterMember }) => {
  const change = member.teamChange;
  return (
    <TableCell className="w-56 max-w-64 min-w-40 p-1 wrap-break-word whitespace-normal">
      {change ? (
        <Stack align="start" gap={1}>
          {SIDES.map((side) => (
            <span key={side.key}>
              <span className="text-xs text-subtle">{side.label}</span>
              {change[side.key].length
                ? change[side.key].map((team, index) => (
                    <Fragment key={team.id}>
                      {index > 0 && ", "}
                      {team.changed ? (
                        <mark className={side.mark}>{team.name}</mark>
                      ) : (
                        <span className="text-subtle">{team.name}</span>
                      )}
                    </Fragment>
                  ))
                : "No team"}
            </span>
          ))}
        </Stack>
      ) : (
        <span className="text-subtle">{member.teamNames}</span>
      )}
    </TableCell>
  );
};
